import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { EntDirectoryInfoName } from "../../../../models/directoryInfoName";
import {
    useAddTransportStatusMutation,
    useDeleteTransportStatusMutation,
    useEditTransportStatusMutation
} from "../../../../redux/api/handBooksApi/transportStatusApi";
import { getCookie } from "typescript-cookie";

const useTransportStatus = (modal: any, refresh?: () => void) => {
    const { t } = useTranslation()
    const { confirm } = modal;
    const [addTransportStatus] = useAddTransportStatusMutation();
    const [deleteTransportStatus] = useDeleteTransportStatusMutation();
    const [editTransportStatus] = useEditTransportStatusMutation();

    async function onAddTransportStatus(newTransportStatus: EntDirectoryInfoName): Promise<boolean> {
        try {
            let status: boolean = false;
            await addTransportStatus(newTransportStatus).then((response: any) => {
                if (response.error) {
                    const isKyrgyz = getCookie('i18next') === 'ky';
                    const lang = isKyrgyz ? 'kg' : 'ru';
                    const res = response.error.data?.res;
                    const errorMessages = Array.isArray(res)
                        ? res.map((error: any) => error[lang] || error.ru).join('\n')
                        : response.error.data?.msg || t('unknownError'); 
                    throw new Error(errorMessages);
                }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if(refresh) refresh();
                }
            }).catch((error:any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });
          
            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }

    async function onDeleteTransportStatus(transportStatus: EntDirectoryInfoName) {
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deleteTransportStatus(transportStatus.id as number).then((response: any) => {
                        if (response.error) {
                            const isKyrgyz = getCookie('i18next') === 'ky';
                            const lang = isKyrgyz ? 'kg' : 'ru';
                            const res = response.error.data?.res;
                            const errorMessages = Array.isArray(res)
                                ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                : response.error.data?.msg || t('unknownError'); 
                            throw new Error(errorMessages);
                        }
                        if (response.data.success) {
                            status = true;
                            Modal.success({title: t('msg.successDelete')});
                            if(refresh) refresh();
                        }
                    }).catch((error: any) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });
                        
                    });
                }
            })
            return status
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    }

    async function onEditTransportStatus(editedTransportStatus: EntDirectoryInfoName): Promise<boolean> {
        try {
            let status: boolean = false;
            await editTransportStatus(editedTransportStatus).then((response: any) => {
                if (response.error) {
                                            const isKyrgyz = getCookie('i18next') === 'ky';
                                            const lang = isKyrgyz ? 'kg' : 'ru';
                                            const res = response.error.data?.res;
                                            const errorMessages = Array.isArray(res)
                                                ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                                : response.error.data?.msg || t('unknownError'); 
                                            throw new Error(errorMessages);
                                        }
                if (response.data.success) {
                    status = true;
                    Modal.success({title: t('msg.successEdited')});
                    if(refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };
    return { onAddTransportStatus,onDeleteTransportStatus, onEditTransportStatus }

}
export { useTransportStatus };

